import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PhoneNumberWithPrefixRequest {
  @jsonMember(String)
  public readonly prefix!: string;

  @jsonMember(String)
  public readonly number!: string;

  public constructor(
    private readonly data: {
      prefix: string;
      number: string;
    },
  ) {
    this.prefix = this.data.prefix;
    this.number = this.data.number;
  }
}
